import React, { useContext, useState, useEffect } from "react";
import { WindowSizeContext } from "../../../../../../../../context/WindowSizeContext";

export default function BusquedaCursos({
  setFilterText = () => {},
  setBusquedaActiva = () => {},
}) {
  const { width } = useContext(WindowSizeContext);
  const [vIsSelected, setVIsSelected] = useState(false);
  const [vIsFocusInput, setVIsFocusInput] = useState(false);
  const [vTexto, setVTexto] = useState("");

  // Notificar al padre cuando el estado de búsqueda cambia
  useEffect(() => {
    const activa = (vIsSelected || vIsFocusInput) && width <= 479;
    setBusquedaActiva(activa);  // Se actualiza el estado en el componente principal
  }, [vIsSelected, vIsFocusInput, width, setBusquedaActiva]);

  // Lógica para los estilos dinámicos
  const mStyle = () => {
    const activo = vIsSelected || vIsFocusInput;
    if (activo) {
      return {
        width: width <= 479 ? "100%" : "calc(100% - 230px)", 
        minWidth: width <= 479 ? "100%" : 100,
        maxWidth: width <= 479 ? "100%" : 260,
        
      };
    }
    return {
      width: 33,
      minWidth: 33,
      maxWidth: 33,
      padding: 6,
      borderRadius: 15,
      backgroundColor: "transparent",
    };
  };

  // Función que maneja el clic para activar el buscador
  const handleSearchClick = () => {
    if (width <= 479) {
      setVIsSelected(true);  // Activa la expansión
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setVTexto(value);
    setFilterText(value);                    // ← actualiza filtro
    setBusquedaActiva(value.trim().length > 0); // ← “hay texto”
  };
  

  return (
    <div
      className="busqueda"
      style={mStyle()}
      onMouseEnter={() => setVIsSelected(true)}
      onMouseLeave={() => {
        if (vTexto.length === 0) {
          setVIsSelected(false);  // Solo se oculta si no hay texto
        }
      }}
    >
      {/* Icono de búsqueda solo cuando no está activo */}
      {!vIsSelected && !vIsFocusInput && <i className="fi fi-rs-search icon-3"></i>}

      <div className="buscar-3-titulo">
        <input
          type="text"
          placeholder="Buscar"
          className="buscar-3-texto"
          onFocus={() => setVIsFocusInput(true)}
          onBlur={() => setVIsFocusInput(false)}
          onClick={handleSearchClick} // Activamos el clic para expandir
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
